import React from "react";

const ChipsList = ({ chipsList, selectedChips }) => {
  const styling = (value) => {
    return selectedChips.some((chip) => chip.value === value)
      ? { scale: "1.25", px: "5px" }
      : { scale: "0.85", px: "0px" };
  };
  return (
    <ul className=" lg:flex hidden flex-col gap-y-2 absolute top-1/2 -translate-y-1/2 2xl:left-4 xl:left-3 lg:left-2 md:left-1">
      {chipsList?.map(({ value, url }, index) => {
        const { scale, px } = styling(value);
        return (
          <li key={index}>
            <img
              style={{
                scale: `${scale}`,
                paddingBlock: `${px}`,
              }}
              alt={`chips${value}-image`}
              src={url}
              className="2xl:w-auto xl:w-auto lg:w-[40px] md:w-[35px]"
            />
          </li>
        );
      })}
    </ul>
  );
};

export default ChipsList;
